export const API_BASE_URL = "https://ukulele-seekho-backend.vercel.app";

export const API_ENDPOINTS = {
  getKey: `${API_BASE_URL}/payments/get-key`,
  createOrder: `${API_BASE_URL}/payments/create/order`,
  verifyPayment: `${API_BASE_URL}/payments/verify`,
  sendMail: `${API_BASE_URL}/mail/send`,
};
